// Primitivi i18n condivisi (client + prerender). Nessuna dipendenza da React qui.
export const LOCALES = ["it", "fr", "en", "de", "es"] as const;
export type Locale = (typeof LOCALES)[number];

// L'italiano è la lingua di default e NON ha prefisso nell'URL ("/").
// Le altre lingue vivono sotto un prefisso ("/fr", "/en", "/de", "/es").
export const DEFAULT_LOCALE: Locale = "it";

export const NON_DEFAULT_LOCALES: Locale[] = LOCALES.filter(
  (l) => l !== DEFAULT_LOCALE,
);

export function isLocale(value: string): value is Locale {
  return (LOCALES as readonly string[]).includes(value);
}

// Codice da usare nell'attributo <html lang="...">.
export const HTML_LANG: Record<Locale, string> = {
  it: "it",
  fr: "fr",
  en: "en",
  de: "de",
  es: "es",
};

// Valore per og:locale.
export const OG_LOCALE: Record<Locale, string> = {
  it: "it_IT",
  fr: "fr_FR",
  en: "en_US",
  de: "de_DE",
  es: "es_ES",
};

// Valore hreflang per gli alternate.
export const HREFLANG: Record<Locale, string> = {
  it: "it",
  fr: "fr",
  en: "en",
  de: "de",
  es: "es",
};

// Etichetta breve mostrata nel selettore lingua.
export const LOCALE_LABEL: Record<Locale, string> = {
  it: "Italiano",
  fr: "Français",
  en: "English",
  de: "Deutsch",
  es: "Español",
};

// Etichetta compatta (codice) per il selettore.
export const LOCALE_SHORT: Record<Locale, string> = {
  it: "IT",
  fr: "FR",
  en: "EN",
  de: "DE",
  es: "ES",
};
